<ng-template #loadingWidgets>
    <mat-chip-set [ngClass]="['widget-list', 'widgets-loading']" animated>
        <mat-chip disabled></mat-chip>
        <mat-chip disabled></mat-chip>
        <ng-container *ngIf="!twoGridLayout">
            <mat-chip disabled></mat-chip>
            <mat-chip disabled></mat-chip>
        </ng-container>
    </mat-chip-set>
</ng-template>

<ng-container *ngIf="!isLoadingInitialData; else loadingWidgets">
    <mat-chip-set #loadedWidgetList
                  [ngClass]="{ 'widget-list': true, 'empty-list': widgets.length === 0 }"
                  [attr.aria-label]="'available widgets selection'"
                  animated delayed>
        <mat-chip *ngFor="let widget of widgets.slice(widgetIndex, widgetIndex + (twoGridLayout ? 2 : 4))"
                  [disableRipple]="true"
                  [highlighted]="selectedWidget.selected[0].label === widget.label"
                  (click)="toggleWidget(widget)">
            <span class="widget-total">{{ widget.total }}</span>
            <span class="widget-label">
                <span class="no-wrap">{{ widget.label | capitalize }}</span>
            </span>
        </mat-chip>
    </mat-chip-set>
</ng-container>

<mat-toolbar>
    <flex-spacer></flex-spacer>

    <button *ngIf="widgets.length > (twoGridLayout ? 2 : 4)"
            class="previous"
            mat-icon-button disableRipple
            [attr.aria-label]="'Show previous widgets'"
            [disabled]="isLoadingInitialData || widgetIndex === 0"
            (click)="prevSet()">
        <mat-icon>arrow_back</mat-icon>
    </button>

    <button-spacer *ngIf="!twoGridLayout" size="sm"></button-spacer>

    <button *ngIf="widgets.length > (twoGridLayout ? 2 : 4)"
            class="next"
            mat-icon-button disableRipple
            [attr.aria-label]="'Show next widgets'"
            [disabled]="isLoadingInitialData || lastPage"
            (click)="nextSet()">
        <mat-icon>arrow_forward</mat-icon>
    </button>

    <flex-spacer *ngIf="twoGridLayout"></flex-spacer>
</mat-toolbar>
